import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable } from '@shapeable/types';
import { Space } from '@shapeable/doing-co-types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ComponentPropsProvider, ExplorerEntityDetailsLayout, ExplorerEntityDetailsLayoutDefaultProps, ExplorerEntityDetailsLayoutProps, ExplorerProvider, ExplorerTabs, SiteHeaderLayout, SiteHeaderProvider, SliceLayoutBoundary } from '@shapeable/ui';
import { SpaceHalfBanner } from './space-half-banner';
const cls = classNames('space-explorer-layout');

// -------- Types -------->

// -------- Props -------->

export type SpaceExplorerLayoutProps = ExplorerEntityDetailsLayoutProps & { 
  entity: Space;
};

export const SpaceExplorerLayoutDefaultProps: Omit<SpaceExplorerLayoutProps, 'entity'> = {
  ...ExplorerEntityDetailsLayoutDefaultProps,
  isAsideSticky: false,
  showAsideHeader: false,
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const LayoutStyles = breakpoints({
  base: css`
    .shp--entity-banner {
      h2.shp--entity-value__name {
       font-size: ${theme.FONT_SIZE(20)};
      }
    }
  `,
  landscape: css`
    .shp--entity-banner {
      h2.shp--entity-value__name {
       font-size: ${theme.FONT_SIZE(30)};
      }
    }
  `,
});

const HeaderStyles = breakpoints({
  base: css`
    margin-bottom: ${theme.UNIT(6)};
  `,
});

const TabsStyles = breakpoints({
  base: css`
    
  `,
});

// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Header: styled(SiteHeaderLayout)`${HeaderStyles}`,
    Layout: styled(ExplorerEntityDetailsLayout)`${LayoutStyles}`,
    Tabs: styled(ExplorerTabs)`${TabsStyles}`,
};

export const SpaceExplorerLayout: Shapeable.FC<SpaceExplorerLayoutProps> = (props) => {
  const { className, entity } = props;

  return (
      <ExplorerProvider>
        <My.Container>
          <My.Header />
          <My.Tabs useStickyStyle />
          <SliceLayoutBoundary boundary='none' >
            <My.Layout 
              entity={entity}
              className={cls.name(className)}
              stickyTopOffset={125}
              asideMaxWidth={800}
              asideIsOffset={false}
              showAsideHeader={false}

              banner={
                <SpaceHalfBanner entity={entity} />
              }
            />
          </SliceLayoutBoundary>
        </My.Container>
      </ExplorerProvider>

  )
};

SpaceExplorerLayout.defaultProps = SpaceExplorerLayoutDefaultProps;
SpaceExplorerLayout.cls = cls;